// Constants extracted from NavigationModule.js

// Constants
export const NAME = "navigation";
export const UPDATE_NAVIGATION_OBJECT = "UPDATE_NAVIGATION_OBJECT" + " " + NAME;
export const CAMPAIGN_KEYWORDS = [
  { key: "utm_source", value: "direct" },
  { key: "utm_medium" },
  { key: "utm_campaign" },
  { key: "utm_content" },
  { key: "utm_term" },
];
// ROUTE_TYPES Constant was shifted from AppComponents/GlobalSearchBar/components/Utils.js in order to resolve circular dependency
export const ROUTE_TYPES = {
  HOMEROOTROUTE: "HOMEROOTROUTE",
  HOMEROUTE: "HOMEROUTE",
  ADMINROUTE: "ADMINROUTE",
  FEATUREROUTE: "FEATUREROUTE",
};

export const TEACHER_PROFILE_NAV_CONTEXT = {
  ADMIN: "ADMIN",
  SCHOOL: "SCHOOL",
  ACCOUNT_SETTINGS: "ACCOUNT_SETTINGS",
  TODDLE_LIBRARY: "TODDLE_LIBRARY",
  CURRICULUM: "CURRICULUM",
};
